<template>
  <b-modal
    :id="`destroy-subscription-${subscription.id}`"
    :modal-class="'default-modal modal-small'"
    :hide-footer="true"
    ref="destroySubscription"
    @hidden="hide"
  >
    <template v-slot:modal-title>
    </template>

    <template v-slot:default>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <div class="text-center">
        <BaseIcon
          size="medium"
        >
          <WarningIcon />
        </BaseIcon>
        <h2 class="font-weight-bold font-size-medium text-color2">Atenção!</h2>
        <p>Você tem certeza que quer cancelar sua assinatura de <strong class="text-color2">{{ subscription.entity && subscription.entity.name || entityName }}</strong>?</p>
        <p>Essa ação é <strong class="text-color2">irreversível</strong>. Caso queira voltar, terá que fazer uma assinatura nova com o preço vigente no momento.</p>
        <div class="mt-4">
          <Button
              class="btn-primary btn-sm mr-2"
              :loading="loader"
              @click="submit"
            >
            Cancelar
          </Button>
          <Button
            class="btn-outline-color2 btn-sm"
            @click="hide"
          >
            Fechar
          </Button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>

import SubscriptionsService from '@/modules/subscriptions/services/subscriptions-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import BaseIcon from '@/components/common/Icon/BaseIcon'
import Button from '@/components/common/Button/Button'
import WarningIcon from '@/components/common/Icon/WarningIcon'

export default {
  name: 'DestroySubscriptionModal',
  props: ['subscription', 'entityName'],
  components: {
    AlertWraper,
    BaseIcon,
    Button,
    WarningIcon
  },
  data () {
    return {
      errors: null,
      loader: false
    }
  },
  methods: {
    async submit () {
      this.errors = null
      this.loader = true
      try {
        await SubscriptionsService.destroySubscription(this.subscription.id)
        this.$bvModal.hide(`destroy-subscription-${this.subscription.id}`)
        const notification = {
          notification: {
            type: 'success',
            content: 'Assinatura cancelada com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$emit('subscription-destroyed', this.subscription.id)
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    hide () {
      this.errors = null
      this.$bvModal.hide(`destroy-subscription-${this.subscription.id}`)
    }
  }
}
</script>
